import React, { useEffect, useState } from "react";
import {
  Deputy__Location,
  getStaff_geoTagList_fromDataBase,
} from "../../CrudOperations/GetOperation";
import { toast } from "react-toastify";

const DeputyLocation = () => {
  const [coords, setCoords] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [DeputyList, setDeputyList] = useState([]);

  const [selectedMedia, setSelectedMedia] = useState(null);
  const [selectedType, setSelectedType] = useState("");

  useEffect(() => {
    const fetchStaffs = async () => {
      const response = await Deputy__Location();

      console.log(response);

      if (
        response?.data?.message ==
        "Allotted staff for today's events retrieved successfully."
      ) {
        setDeputyList(response?.data?.data);
      }
    };
    fetchStaffs();
  }, []);

  const handleSearchInput = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredList = DeputyList.filter(
      (p) =>
        p.StaffName.toLowerCase().includes(query) ||
        p.AreaName.toLowerCase().includes(query)
    );

    setDeputyList(filteredList);
  };

  const getDeputyLocationById = async (AllottedStaffId) => {
    try {
      const response = await fetch(
        `https://dlapi.wipenex.com/api/geoTag/GeoTagLocationDetails/${AllottedStaffId}`
      );
      const result = await response.json();
      console.log(result);
      
      return result;
    } catch (error) {
      console.error("Failed to fetch deputy location", error);
      return null;
    }
  };

  const handleClick = async (AllottedStaffId) => {
    console.log(AllottedStaffId);

    const data = await getDeputyLocationById(AllottedStaffId);
    console.log(data);

    if (data?.message === "Latest location data retrieved.") {
      if (data?.data?.Latitude && data?.data?.Longitude) {
        window.open(
          `https://www.google.com/maps?q=${data?.data?.Latitude},${data?.data?.Longitude}`,
          "_blank"
        );
      } else {
        console.warn("Coordinates not found.");
      }
    } else {
      toast.warn(data?.message);
    }
  };

  return (
    <div className="container mx-auto p-8 bg-white rounded-lg shadow-lg shadow-gray-300">
      <h1 className="text-xl font-inter font-bold mb-6 border-b-4 border-blue-600 pb-2 text-gray-800">
        Deputy Location
      </h1>

      <div className="mb-6 flex justify-between items-center">
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchInput}
          className="w-1/2 border border-gray-300 p-3 rounded-md transition duration-200 focus:outline-none focus:ring-2 focus:ring-blue-500 shadow-sm"
        />
      </div>

      {/* Responsive table wrapper */}
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white table-auto border border-gray-300 rounded-lg shadow-sm">
          <thead className="bg-gray-100">
            <tr>
              {[
                "S.No",
                "Deputy Name",
                "AreaName",
                "EventName",
                "EventStartDate",
                "EventEndDate",
                "Location",
              ].map((heading) => (
                <th
                  key={heading}
                  className="py-3 px-4 text-center font-semibold text-gray-700"
                >
                  {heading}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {console.log(DeputyList)}

            {DeputyList.length > 0 ? (
              DeputyList.map((p, index) => (
                <tr
                  key={p.StaffId}
                  className="border-b transition-colors duration-200 hover:bg-gray-50"
                >
                  <td className="py-3 px-4 text-center">{index + 1}</td>
                  <td className="py-3 px-4 text-center">{p.StaffName}</td>

                  <td className="py-3 px-4 text-center">{p.AreaName}</td>
                  <td className="py-3 px-4 text-center">{p.EventName}</td>

                  <td className="py-3 px-4 text-center">
                    {new Date(p.EventStartDate)
                      .toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                      .replace(",", " at")}
                  </td>

                  <td className="py-3 px-4 text-center">
                    {new Date(p.EventEndDate)
                      .toLocaleString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                        hour: "2-digit",
                        minute: "2-digit",
                        hour12: false,
                      })
                      .replace(",", " at")}
                  </td>

                  <td
                    className="py-3 px-4 text-center"
                    onClick={() => handleClick(p.AllottedStaffId)}
                  >
                    <div className="text-blue-500 hover:underline flex items-center justify-center gap-1 cursor-pointer">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className="h-5 w-5 text-red-600"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 11c1.656 0 3-1.343 3-3s-1.344-3-3-3-3 1.343-3 3 1.344 3 3 3z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 2C8.134 2 5 5.134 5 9c0 6 7 13 7 13s7-7 7-13c0-3.866-3.134-7-7-7z"
                        />
                      </svg>
                      View
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr key={"unique-key"}>
                <td colSpan="9" className="py-3 text-center text-gray-600">
                  No Staffs found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {selectedMedia && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-6 rounded shadow-lg max-w-md w-full relative">
            <button
              className="absolute top-2 right-3 text-red-500 text-xl"
              onClick={() => setSelectedMedia(null)}
            >
              ×
            </button>

            {selectedType === "image" ? (
              <img
                src={`https://dlapi.wipenex.com/${selectedMedia}`}
                alt="Media"
                className="w-96 h-96 rounded"
              />
            ) : selectedType === "video" ? (
              <video controls className="rounded w-96 h-96">
                <source
                  src={`https://dlapi.wipenex.com/${selectedMedia}`}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            ) : (
              <p>Unsupported media type</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DeputyLocation;
